module.exports = __webpack_public_path__ + "static/media/two.9c6efd85.png";